<template>
    <div class="flex w-full flex-col items-stretch">
        <InertiaLink
            :href="route('profile.show')"
            class="block px-4 py-2 text-left text-sm text-gray-600 hover:bg-gray-100"
            data-testid="profile-link"
        >
            {{ __('Profile') }}
        </InertiaLink>
        <button
            type="button"
            class="block px-4 py-2 text-left text-sm text-gray-600 hover:bg-gray-100"
            data-testid="logout-button"
            @click="router.post(route('logout'))"
        >
            {{ __('Logout') }}
        </button>
    </div>
</template>

<script setup lang="ts">
import { Link as InertiaLink, router } from '@inertiajs/vue3';
</script>
